import $axios from '@/axios-instance.js'

class ChannelMessagesServiceClass {
  baseUrl = '/api/v1/admin/channels'
  child = 'messages'

  // Read all - findAll
  index(channel, params) {
    return $axios.get(`${this.baseUrl}/${channel}/${this.child}`, params)
  }

  // Read one - show
  show(channel, id, params) {
    return $axios.get(`${this.baseUrl}/${channel}/${this.child}/${id}`, params)
  }
}
export const ChannelMessagesService = new ChannelMessagesServiceClass()
